import React, { useState } from "react";
import moment from "moment";
import { Form, Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import Select from "../../components/Select";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import "moment/locale/he";
import { GiMagnifyingGlass } from "react-icons/gi";

const TimeRanges = {
  LAST_SIX_MONTHS: "LAST_SIX_MONTHS",
  LAST_YEAR: "LAST_YEAR",
  CUSTOM: "CUSTOM",
  TWO_YEARS: "TWO_YEARS"
};

const ArchiveDesktopSearchForm = ({ startTime, endTime, searchCallback, lookups, orderByAmount, totalSearchAmount, transactionCount }) => {
  const [start, setStart] = useState(startTime ? moment(startTime) : moment().startOf("month"));
  const [end, setEnd] = useState(endTime ? moment(endTime) : moment().endOf("month"));
  const [text, setText] = useState("");
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedTimeRange, setSelectedTimeRange] = useState(TimeRanges.LAST_SIX_MONTHS);
  const [showCustomTimeRange, setShowCustomTimeRange] = useState(false);
  const [approvedOnly, setApprovedOnly] = useState(false);

  const parseTime = () => {
    let s = start;
    if (selectedTimeRange === TimeRanges.LAST_SIX_MONTHS) s = moment().subtract(6, "month").toDate();
    else if (selectedTimeRange === TimeRanges.LAST_YEAR) s = moment().subtract(1, "year").toDate();
    else if (selectedTimeRange === TimeRanges.TWO_YEARS) s = moment().subtract(2, "year").toDate();
    return { startTime: s, endTime: end };
  };

  const handleSearch = () => {
    const { startTime, endTime } = parseTime();
    searchCallback({ startTime, endTime, text, tags, categories, approvedOnly });
  };

  const cardStyle = {
    background: "white",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px"
  };

  return (
    <div style={{ ...cardStyle, direction: "rtl", width: "100%" }}>
      <div style={{ margin: "20px", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex" }}>
          <Form.Group style={{ margin: "10px", width: "200px", zIndex: 999 }}>
            <Form.Label>קטגוריות</Form.Label>
            <Select
              options={lookups.categories}
              multi
              onSelect={setCategories}
              placeholder="קטגוריות"
              isSearchable
            />
          </Form.Group>
          <Form.Group style={{ margin: "10px", minWidth: "200px", zIndex: 999 }}>
            <Form.Label>תגיות</Form.Label>
            <Select
              options={lookups.tags}
              multi
              onSelect={setTags}
              placeholder="תגיות"
              isSearchable
            />
          </Form.Group>
          <div style={{ margin: "10px" }}>
            <Form.Group className="mb-3">
              <Form.Label>טקסט</Form.Label>
              <Form.Control
                type="text"
                placeholder="טקסט לחיפוש"
                onChange={(e) => setText(e.target.value)}
              />
            </Form.Group>
          </div>
          <div style={{ height: "40px", margin: "20px" }}>
            <Button
              style={{ background: "rgb(255, 102, 102)", borderRadius: "17px", borderColor: "rgb(255, 102, 102)" }}
              onClick={handleSearch}
            >
              <GiMagnifyingGlass />
            </Button>
            <Button
              style={{ marginRight: "20px", background: "rgb(255, 102, 102)", borderRadius: "17px", borderColor: "rgb(255, 102, 102)" }}
              onClick={orderByAmount}
            >
              מיין
            </Button>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <input
            style={{ marginLeft: "10px" }}
            type="checkbox"
            className="form-check-input"
            id="approvedOnlyCheck"
            onChange={(e) => setApprovedOnly(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="approvedOnlyCheck">
            הצג פעולות שאושרו בלבד
          </label>
        </div>

        <div>
          <ButtonGroup style={{ margin: "10px" }}>
            {[
              { label: "6 חודשים", value: TimeRanges.LAST_SIX_MONTHS },
              { label: "שנה", value: TimeRanges.LAST_YEAR },
              { label: "שנתיים", value: TimeRanges.TWO_YEARS },
              { label: "טווח", value: TimeRanges.CUSTOM }
            ].map(({ label, value }, index) => (
              <ToggleButton
                key={index}
                style={{ marginRight: "10px" }}
                id={`radio-${index}`}
                type="radio"
                variant="outline-primary"
                value={value}
                checked={selectedTimeRange === value}
                onClick={() => setShowCustomTimeRange(value === TimeRanges.CUSTOM)}
                onChange={() => setSelectedTimeRange(value)}
              >
                {label}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>
      </div>

      <div style={{ margin: "20px", width: "200px" }}>
        {showCustomTimeRange && (
          <>
            <Form.Group>
              <Form.Label>תאריך התחלה</Form.Label>
              <Datetime
                locale="he"
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                closeOnSelect
                value={start}
                onChange={setStart}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>תאריך סיום</Form.Label>
              <Datetime
                locale="he"
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                closeOnSelect
                value={end}
                onChange={setEnd}
              />
            </Form.Group>
          </>
        )}
      </div>

      <div style={{ margin: "20px" }}>
        <div style={{ marginTop: "20px", direction: "rtl", display: "flex" }}>
          <div style={{ textAlign: "right", fontWeight: "bold" }}>סכום כולל:</div>
          <div style={{ marginRight: "10px", direction: "ltr" }}>{totalSearchAmount}</div>
        </div>
        <div style={{ marginTop: "10px", paddingBottom: "10px", direction: "rtl", display: "flex" }}>
          <div style={{ textAlign: "right", fontWeight: "bold" }}>מספר פעולות:</div>
          <div style={{ marginRight: "10px" }}>{transactionCount}</div>
        </div>
      </div>
    </div>
  );
};

export default ArchiveDesktopSearchForm;